import axios from 'axios';

const uploadProductDocument = (productId, file, docType = 'article_pdf') => {
  const formData = new FormData();
  formData.append('document', file);
  formData.append('productId', productId);
  formData.append('docType', docType);
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/product/uploadProductDocument`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(res => res)
    .catch(err => err);
};

export default uploadProductDocument;
